import { render } from "./StartOrder.vue?vue&type=template&id=6ca57a47&scoped=true"
import script from "./StartOrder.vue?vue&type=script&lang=js"
export * from "./StartOrder.vue?vue&type=script&lang=js"

import "./StartOrder.vue?vue&type=style&index=0&id=6ca57a47&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca57a47"]])

export default __exports__